// extracted by mini-css-extract-plugin
export default {"label":"InfoItem-module__label--K23Tu","wrapper":"InfoItem-module__wrapper--5WOSP","isInline":"InfoItem-module__isInline--lcqBn"};